import { ObjectSchema, StringSchema, addMethod, object, string } from 'icreate/common/validators/index';
import * as yup from 'yup';
import { locale } from 'icreate/common/validators/yup-locale';
import 'icreate/common/validators/custom-method';
yup.setLocale(locale);

export function versionDialogValidator(): ObjectSchema<VersionDialog> {
    return object({
        versionName: string().IsVersionNumber().required().nonNullable().strict(),
        assignedTo: object({
            name: string().required().nonNullable().strict(),
            oid: string().uuid().required().nonNullable().strict(),
            email: string().email().required().nonNullable().strict(),
        })
            .required()
            .nonNullable()
            .strict()
            .noUnknown(),
    })
        .strict()
        .noUnknown();
}

class VersionDialog {
    versionName: string;
    assignedTo: { name?: string; oid?: string; email?: string };
}
